import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=2d2a082d&scoped=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=2d2a082d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a082d",
  null
  
)

export default component.exports